// frontend/components/Súpuplan.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import mexico from '../../resources/supur/mexico.jpeg';
import braudsupa from '../../resources/supur/braudsupa.jpeg';
import aspas from '../../resources/supur/aspas.jpeg';
import tomat from '../../resources/supur/tomat.jpeg';
import sveppa from '../../resources/supur/sveppasupa.jpeg';
import bladlauks from '../../resources/supur/bladlaukssupa.jpg';
import gulrotar from '../../resources/supur/gulrotarsupa.jpg';
import Blómkáls from '../../resources/supur/Blomkals.jpg';
import brokkoli from '../../resources/supur/brokkoli.jpg';
import tælensk from '../../resources/supur/tælensk.jpg';
import sætkartoflur from '../../resources/supur/sætkartoflu.jpg';
import papriku from '../../resources/supur/papriku.jpg';
import "./styles.css";

const soupImages = {
    Aspassúpa: aspas,
    Blaðlaukssúpa: bladlauks,
    Brauðsúpa: braudsupa,
    Blómkálssúpa: Blómkáls,
    'Brokkólísúpa': brokkoli,
    'Fiskisúpa': '',
    Gulrótarsúpa: gulrotar,
    'Graskerssúpa': tomat,
    'Íslensk kjötsúpa': '',
    'Sætkartöflusúpa': sætkartoflur,
    "Mexíkósk kjúklingasúpa": mexico,
    'Paprikusúpa': papriku,
    Tómatsúpa: tomat,
    "Rjómalöguð sveppasúpa": sveppa,
    "Tælensk núðlusúpa": tælensk
    
};

const getSoupImage = (name) => {
    if (!name) return '';
    const key = Object.keys(soupImages).find(k => k.toLowerCase() === name.toLowerCase());
    return key ? soupImages[key] : '';
};

const monthNames = [
    'Janúar', 'Febrúar', 'Mars', 'Apríl', 'Maí', 'Júní', 'Júlí', 'Ágúst', 'September', 'Október', 'Nóvember', 'Desember'
];

const formatDate = (date) => {
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    return `${day}. ${month}`;
}

const handleDate = (soupPlan) => {
    const startDate = new Date(soupPlan.week.startDate);
    const endDate = new Date(soupPlan.week.endDate);
    return `${formatDate(startDate)} - ${formatDate(endDate)}`;
}

export const Súpuplan = () => {
    const [soupPlan, setSoupPlan] = useState({
        Monday: '',
        Tuesday: '',
        Wednesday: '',
        Thursday: '',
        Friday: '',
        week: {
            startDate: '',
            endDate: ''
        }
    });

    useEffect(() => {
        axios.get('https://api.kallabakari.is/api/soupPlan')
            .then(response => {
                setSoupPlan(response.data);
            })
            .catch(error => {
                console.error('Error fetching soup plan:', error);
            });
    }, []);

    const days = ['Mánudagur', 'Þriðjudagur', 'Miðvikudagur', 'Fimmtudagur', 'Föstudagur'];

    return (
        <div className="flex flex-col items-center bg-[#FAF7F2] border-t border-amber-100 px-4 py-8 w-full">
            <h2 className="text-2xl md:text-3xl text-stone-900 font-serif mb-1">Súpa dagsins</h2>
            <div className="w-16 h-0.5 bg-[#C29979] mb-2"></div>
            <p className="text-base md:text-xl font-serif text-stone-500 mb-6">{handleDate(soupPlan)}</p>
            <div className="flex flex-wrap md:flex-row w-full justify-around gap-4">
                {days.map(day => (
                    <div key={day} className="flex flex-col items-center w-[45%] md:w-[17%] bg-white rounded-xl border border-amber-100 shadow-sm p-3 hover:shadow-md transition-shadow">
                        <p className="text-base md:text-lg text-stone-700 font-serif font-semibold mb-2">{day}</p>
                        <div className="w-full h-px bg-amber-100 mb-2"></div>
                        <img src={getSoupImage(soupPlan[day])} alt={soupPlan[day]} className="w-full rounded-lg object-contain"/>
                        <p className="text-sm text-center md:text-base text-stone-600 font-serif mt-2">{soupPlan[day]}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Súpuplan;
